export const routes = {
  home: '/',
  product: '/product/:id',
  addReview: '/product/addReview/:id',
  cart: '/cart',
  contact: '/contact',
  about: '/about',
  drums: '/drums',
  drumsId: '/drums/:id',
  cymbalsId: '/cymbals/:id',
  cymbals: '/cymbals',
  login: '/login',
  checkout: '/checkout',
  policy: '/privacy-policy',
};
